import { useUserStore } from '@/store/modules/user'

const hasKakao = () => {
  return !!window.Kakao
}

export const shareByKakao = (requestUrl: string, templateId?: number, query?: string) => {
  if(hasKakao()) {
    let data
    if (templateId) {
      data = {
        requestUrl,
        templateId,
        templateArgs: {
          query,
        },
      }
    } else {
      data = {
        requestUrl,
      }
    }

    window.Kakao.Share.sendScrap(data);
  }
}

export const handleShare = async (utmContent: string, utmCampaign?: string, utmId?: string) => {
  const userStore = useUserStore()
  const refCode = await userStore.getRefCode()

  const searchParams = new URLSearchParams()

  searchParams.append('utm_source', 'customer_recommend')
  searchParams.append('utm_medium', 'referral')
  searchParams.append('utm_content', utmContent)
  searchParams.append('ref_code', refCode)
  if (utmCampaign) {
    searchParams.append('utm_campaign', utmCampaign)
  }
  if (utmId) {
    searchParams.append('utm_id', utmId)
  }
  const targetUrl = `https://app.sole.overtax.co.kr/landing?${searchParams.toString()}`
  shareByKakao(targetUrl)
}
